import React from 'react';
import { CheckIcon, ChevronRightIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { SectionHeading } from './SectionHeading';
import { volumes } from '../data/volumes';
export function VolumesSection() {
  return <section className="w-full bg-navy-950 px-5 py-16 text-white sm:py-20" data-id="element-325" data-mp="cnzexi63p3ej">
      <div className="mx-auto max-w-4xl" data-id="element-326" data-mp="7qhdecuexqgk">
        <SectionHeading tone="dark" kicker="What you'll find inside" title={<>
              6 premium volumes. <span className="text-electric-400" data-id="element-328" data-mp="3c4fj8wkxbc76">One structured TCM workflow.</span>
            </>} data-id="element-327" data-mp="7nleal6twvqj" />

        <ol className="mt-12 space-y-6" data-id="element-329" data-mp="3pvsyvzfpnpwx">
          {volumes.map(v => <li key={v.number} className="rounded-3xl bg-navy-900 p-6 sm:p-9" data-id="element-330" data-mp="3l42ipcu3e7xl">
              <div className="flex items-start gap-4" data-id="element-331" data-mp="2xego72oo0gvx">
                <span className="flex h-16 w-16 shrink-0 flex-col items-center justify-center rounded-2xl bg-electric-500 font-display leading-none" data-id="element-332" data-mp="2xcx5z6jg7vri">
                  <span className="text-[11px] font-bold uppercase tracking-widest text-navy-950" data-id="element-333" data-mp="29g0j8dpsdqoa">Vol</span>
                  <span className="text-[28px] font-black text-white" data-id="element-334" data-mp="2edtnh17j4alx">{v.number}</span>
                </span>
                <div className="min-w-0" data-id="element-335" data-mp="2j6cz3smnovo3">
                  <h3 className="font-display text-[28px] font-extrabold uppercase leading-[1.02] text-white sm:text-4xl" data-id="element-336" data-mp="2j7eluud1b6ln">
                    {v.title}
                  </h3>
                  <p className="mt-2 text-[16px] font-semibold leading-snug text-gold-400" data-id="element-337" data-mp="1qi7fj97c9cpu">{v.tagline}</p>
                </div>
              </div>

              <div className="mt-6 space-y-3 text-[16px] leading-relaxed text-slate-300" data-id="element-338" data-mp="20f2c3mk1x31h">
                {v.intro.map(p => <p key={p} data-id="element-339" data-mp="24hgsm008zqpl">{p}</p>)}
              </div>

              {v.listIntro && <p className="mt-5 text-[16px] font-semibold text-white" data-id="element-340" data-mp="3buqwq79u1pz4">{v.listIntro}</p>}
              <ul className="mt-4 grid gap-x-6 gap-y-2.5 sm:grid-cols-2" data-id="element-341" data-mp="3fv1e0g32s2ta">
                {v.items.map((item, i) => <li key={item} className="flex gap-3 text-[15px] leading-snug text-slate-100" data-id="element-342" data-mp="1gprnuwjnfnju" data-mpi={i}>
                    {v.ordered ? <span className="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-cta-500 text-xs font-bold text-navy-950" data-id="element-343" data-mp="1btu6cmwngb5h">
                        {i + 1}
                      </span> : <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta-400" strokeWidth={3} aria-hidden="true" data-id="element-344" data-mp="x2k3mi3trnxu" />}
                    <span data-id="element-345" data-mp="t2jjqhxyikje">{item}</span>
                  </li>)}
              </ul>

              {v.formula && <div className="mt-6" data-id="element-346" data-mp="16uhji25s342w">
                  <p className="text-[15px] font-semibold text-white" data-id="element-347" data-mp="121oedd6edtqa">Each troubleshooting route follows a consistent format:</p>
                  <div className="mt-3 flex flex-wrap items-center gap-1.5" data-id="element-348" data-mp="earcyuc8aeta">
                    {v.formula.map((step, i) => <React.Fragment key={step} data-id="element-349" data-mp="9beqwbt6lbrr" data-mpi={i}>
                        <span className="rounded-lg bg-electric-500/15 px-2.5 py-1.5 text-[13px] font-bold text-electric-300" data-id="element-350" data-mp="2kzjkls2nst1a">
                          {step}
                        </span>
                        {i < v.formula!.length - 1 && <ChevronRightIcon className="h-4 w-4 text-slate-500" aria-hidden="true" data-id="element-351" data-mp="2by3c5pven0zp" />}
                      </React.Fragment>)}
                  </div>
                </div>}

              <div className="mt-6 space-y-3 border-t border-white/10 pt-5 text-[15px] leading-relaxed text-slate-300" data-id="element-352" data-mp="38p5k6gmy1a9t">
                {v.outro.map(p => <p key={p} data-id="element-353" data-mp="2zpihzsme40fp">{p}</p>)}
              </div>
            </li>)}
        </ol>

        <CtaButton label="I want all 6 volumes today" tone="dark" className="mt-12" data-id="element-354" data-mp="1jbiiujvdceti" />
      </div>
    </section>;
}